
import NewsletterSubscription from './NewsletterSubscription';

const FooterNewsletterSection = () => <NewsletterSubscription />;

export default FooterNewsletterSection;
